import React from 'react'

import CompactTokensList from '@src/pages/Exchange/components/SelectTokenModal/components/CompactTokensList'
import { IToken } from '@src/types/token'

interface TokenResultsDisplayProps {
    activeChainSelection?: number
    tokenQuery: string
    availableChains: Record<string, any>
    displayedTokens: IToken[]
    getTokenBalance?: (token: IToken) => { tokenBalance: string; usdBalance: string } | undefined
    selectedToken?: IToken
    onTokenClicked: (token: IToken) => void
    searchResult: IToken[]
}

export const TokenResultsDisplay: React.FC<TokenResultsDisplayProps> = ({
    activeChainSelection,
    tokenQuery,
    availableChains,
    displayedTokens,
    getTokenBalance,
    selectedToken,
    onTokenClicked,
    searchResult,
}) => {
    if (activeChainSelection) {
        return (
            <div className='animate-fadeIn'>
                <div className='px-2 pb-2'>
                    <h3 className='animate-slideInRight text-sm font-medium text-token-modal-label-text'>
                        {`Results for "${tokenQuery}" on ${(activeChainSelection !== undefined && availableChains[activeChainSelection]?.name) || 'selected chain'}`}
                    </h3>
                </div>
                <CompactTokensList
                    tokens={displayedTokens}
                    selectedToken={selectedToken}
                    onTokenClicked={onTokenClicked}
                    getTokenBalance={getTokenBalance}
                />
            </div>
        )
    }

    return (
        <div className='animate-fadeIn'>
            <CompactTokensList
                tokens={searchResult}
                selectedToken={selectedToken}
                onTokenClicked={onTokenClicked}
                getTokenBalance={getTokenBalance}
            />
        </div>
    )
}

export default TokenResultsDisplay
